import React from 'react'
import { Row, Col, Button, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import UserAddressCard from './UserAddressCard'
import UseAllAddressUser from '../../CustomHooks/User/UseAllAddressUser'

const UserAllAddressComp = () => {

  const [alladdressList, loading] = UseAllAddressUser();

  return (
    <div className='my-2 d-flex flex-column'>    
      <div className="fw-bold fs-30 dark-color pb-4"> All Address </div>
      <Link to="/user/add-address" className='align-self-end'>           
        <Button className='orange-bg text-white px-5 py-3 mb-3'> Add New Address </Button>
      </Link>
      {loading === false ? ((alladdressList && alladdressList.length >= 1 ? (
        alladdressList.map((item, index) => <UserAddressCard item={item} key={index} />)
      ) : (
        <div className='d-flex align-items-center flex-column justify-content-center mh-100-exact'>
          <h3 className='fs-60'>No Address</h3>
          <Link to="/user/add-address">
            <Button className='orange-bg border-0 px-4 py-3 fs-30'>Add Address</Button>
          </Link>
        </div>))) :
        (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
          <Spinner animation="border" variant="danger" />
        </div>)
      }

    </div>
  )
}

export default UserAllAddressComp
